export default __webpack_public_path__ + "static/media/fasting_overeating@2x.3c6d3f62.jpg";